export default {
  "hero.tag": "By Invitation Only",
  "hero.referral": "",
  "hero.title1": "A spark of creativity,",
  "hero.title2": "transformed into work of lasting value.",
  "hero.description1": "Minimize time and cost losses from 0→1.",
  "hero.description2": "",
  "hero.description3": "We provide an environment without detours.",
  "nav.home": "Home",
  "nav.philosophy": "",
  "nav.curriculum": "Curriculum",
  "nav.instructors": "Instructors",
  "nav.pricing": "Pricing",
  "nav.contact": "Contact",
  "philosophy.label": "",
  "philosophy.title": "",
  "philosophy.description": "",
  "threepillars.label": "Three Pillars",
  "threepillars.title": "Three Special Moments\nThis 6-Month Program Brings",
  "threepillars.pillar1.title": "The Shortest Path to Quality",
  "threepillars.pillar1.subtitle": "Rapid Quality Growth",
  "threepillars.pillar1.desc": "Why not compose a song for someone you love?",
  "threepillars.pillar2.title": "Eliminate Wasted Time",
  "threepillars.pillar2.subtitle": "Eliminate Wasted Time",
  "threepillars.pillar2.desc": "Active professionals handle everything from proposal to purchase and setup — together with you.",
  "threepillars.pillar3.title": "Joy of Creation",
  "threepillars.pillar3.subtitle": "Joy of Creation",
  "threepillars.pillar3.desc": "Bring the joy of creating into your life.",
  "curriculum.tag": "Curriculum",
  "curriculum.title": "Turn Your Value into Lasting Works",
  "curriculum.subtitle": "Strictly curated — only what you need",
  "curriculum.item1.title": "Composition & Arrangement",
  "curriculum.item1.description": "Enrich your music with deep professional insight.\nLet your music grow richer.\nAnd we will walk alongside you until it takes concrete form.",
  "curriculum.item2.title": "DTM / DAW",
  "curriculum.item2.description": "Learning in the same environment as your instructor accelerates\nprogress dramatically.\nCentered on Studio Pro, with full support for Cubase, Ableton, and Logic Pro.",
  "curriculum.item3.title": "Mix",
  "curriculum.item3.description": "Industry-standard mixing techniques.\nFrom spatial design to final polish, learn at a professional-grade studio.",
  "curriculum.item4.title": "Equipment & Setup",
  "curriculum.item4.description": "All necessary equipment proposed and purchased. Zero wasted spending. Start creating immediately.",
  "curriculum.schedule.title": "Learning Schedule",
  "curriculum.schedule.phaseLabel": "Phase",
  "curriculum.schedule.session": "Session {n}",
  "curriculum.schedule.p1s1": "Equipment Introduction & Setup",
  "curriculum.schedule.p1s2": "Foundation Building 1",
  "curriculum.schedule.p1s3": "Foundation Building 2",
  "curriculum.schedule.p1s4": "Review",
  "curriculum.schedule.p2s1": "Practical Production 1",
  "curriculum.schedule.p2s2": "Practical Production 2",
  "curriculum.schedule.p2s3": "Practical Production 3",
  "curriculum.schedule.p2s4": "Review",
  "curriculum.schedule.p3s1": "Practical Production 1",
  "curriculum.schedule.p3s2": "Practical Production 2",
  "curriculum.schedule.p3s3": "Practical Production 3",
  "curriculum.schedule.p3s4": "Review",
  "curriculum.schedule.p4s1": "Practical Production 1",
  "curriculum.schedule.p4s2": "Practical Production 2",
  "curriculum.schedule.p4s3": "Practical Production 3",
  "curriculum.schedule.p4s4": "Review",
  "curriculum.schedule.p5s1": "Practical Production 1",
  "curriculum.schedule.p5s2": "Practical Production 2",
  "curriculum.schedule.p5s3": "Practical Production 3",
  "curriculum.schedule.p5s4": "Review",
  "curriculum.schedule.p6s1": "Practical Production 1",
  "curriculum.schedule.p6s2": "Practical Production 2",
  "curriculum.schedule.p6s3": "Final Polish 1",
  "curriculum.schedule.p6s4": "Final Polish 2",
  "instructors.label": "Instructors",
  "instructors.title1": "World-Class Active Professionals",
  "instructors.title2": "",
  "foundersMessage.label": "Message",
  "foundersMessage.title": "Why I Started This Consulting",
  "foundersMessage.p1": "Thankfully, through SNS and other channels, I have received many inquiries from people saying they want to learn directly from an active professional or seriously pursue a professional career.",
  "foundersMessage.p2": "However, prioritizing my own production work, I was unable to respond to all of them, and that always weighed on my mind.",
  "foundersMessage.p3": "At the same time, if I were to teach, I wanted the goal to be more than just 'being able to make music.' I wanted students to truly acquire the quality and mindset that holds up in professional settings.",
  "foundersMessage.p4": "With that vision, and thanks to the continued requests from so many people, I decided to launch this consulting service.",
  "foundersMessage.p5": "For those seriously aiming to become professionals, or those wanting to gain skills that compete at a commercial level, I will share the knowledge and experience cultivated in the field — in a practical, hands-on way.",
  "testimonials.label": "Voices",
  "testimonials.title": "Testimonials",
  "testimonials.quote": "\"Completely bespoke lessons at my own pace. An experience on a different dimension from any music lesson before.\"",
  "testimonials.author": "K.T. — Executive",

  "pricing.hero.tag": "",
  "pricing.hero.brand1": "From",
  "pricing.hero.brand2": "Zero",
  "pricing.hero.brand3": "to",
  "pricing.hero.brand4": "One",
  "pricing.hero.desc": "",
  "pricing.hero.membership": "Members Only · By Referral",
  "pricing.hero.programLabel": "\"Reaching professional composition quality within 6 months\"\na complete one-on-one consulting program by active professional composers.",

  "pricing.plans.tag": "Service",
  "pricing.plans.title": "Composition Consulting",
  "pricing.plans.subtitle": "",

  "pricing.plan1.name": "In-Person Consulting",
  "pricing.plan1.recommended": "Recommended",
  "pricing.plan1.tag": "FULL SUPPORT",
  "pricing.plan1.price": "¥1,430,000",
  "pricing.plan1.per": "/6 months",
  "pricing.plan1.duration": "",
  "pricing.plan1.enrollment": "Enrollment Fee ¥110,000 included.",
  "pricing.plan1.desc": "Book an exclusive professional studio. Learn with real-time feedback in a luxury acoustic environment — the fastest path to acquiring skills.",
  "pricing.plan1.f1": "4 sessions/month, one-on-one",
  "pricing.plan1.f2": "*Goal: pro composition quality in 6 months",
  "pricing.plan1.f3": "Equipment & software selection support",
  "pricing.plan1.f4": "In-person at a pro-grade studio",
  "pricing.plan1.f5": "Composition & arrangement",
  "pricing.plan1.cta": "Membership Inquiry",

  "pricing.plan2.name": "Online Consulting",
  "pricing.plan2.tag": "FULL SUPPORT",
  "pricing.plan2.price": "¥1,430,000",
  "pricing.plan2.per": "/6 months",
  "pricing.plan2.duration": "",
  "pricing.plan2.enrollment": "Enrollment Fee ¥110,000 included.",
  "pricing.plan2.desc": "Attend from home while viewing the same screen as your instructor. Ideal for busy or remote learners.",
  "pricing.plan2.f_common1": "4 sessions/month, one-on-one",
  "pricing.plan2.f_common2": "4 sessions/month plus optional individual support on separate days",
  "pricing.plan2.f2": "Zoom / Google Meet compatible",
  "pricing.plan2.f3": "Screen sharing for detailed guidance",
  "pricing.plan2.f4": "Composition & arrangement",
  "pricing.plan2.f5": "Equipment & software selection support",
  "pricing.plan2.f6": "*Goal: pro composition quality in 6 months",
  "pricing.plan2.cta": "Membership Inquiry",

  "pricing.equipment.tag": "Equipment Support",
  "pricing.equipment.title": "Equipment Support",
  "pricing.equipment.catchphrase": "We made the \"impossible\" possible.",
  "pricing.equipment.subtitle": "Comprehensive proposals for PC, DAW, sound libraries and subscriptions.\nCurated strictly — only what you truly need.",
  "pricing.equipment.listTitle": "Essentials when starting from scratch",
  "pricing.equipment.item1Name": "WAVES Horizon",
  "pricing.equipment.item1Price": "¥40,700",
  "pricing.equipment.item2Name": "DAW (Studio One recommended)\n※ Cubase, Logic, Ableton compatible",
  "pricing.equipment.item2Price": "¥20,800",
  "pricing.equipment.item3Name": "Logitech trackball mouse",
  "pricing.equipment.item3Price": "¥17,800",
  "pricing.equipment.item4Name": "Audio interface & cables",
  "pricing.equipment.item4Price": "¥40,700",
  "pricing.equipment.item5Name": "Microphone (cable, stand, pop guard included)",
  "pricing.equipment.item5Price": "¥30,700",
  "pricing.equipment.item6Name": "MIDI keyboard",
  "pricing.equipment.item6Price": "—",
  "pricing.equipment.item7Name": "Splice",
  "pricing.equipment.item7Price": "$12.99",
  "pricing.equipment.item1": "WAVES Horizon ¥40,700",
  "pricing.equipment.item2": "DAW (Studio One recommended) ¥20,800\n※ Cubase, Logic, Ableton compatible",
  "pricing.equipment.item3": "Logitech trackball mouse ¥17,800",
  "pricing.equipment.item4": "Audio interface & cables ¥40,700",
  "pricing.equipment.item5": "Microphone (with cable, stand, pop guard included) ¥30,700",
  "pricing.equipment.item6": "MIDI keyboard",
  "pricing.equipment.item7": "Splice $12.99",
  "pricing.equipment.badge": "KEY FEATURE",
  "pricing.equipment.flowLabel": "Setup Flow",
  "pricing.equipment.step1": "Comprehensive equipment proposal",
  "pricing.equipment.step2": "Select and purchase optimal equipment",
  "pricing.equipment.step3": "Environment setup completed on the day of purchase",
  "pricing.equipment.step4": "Start creating immediately from day one",
  "pricing.equipment.cta": "Membership Inquiry",
  "pricing.equipment.note1": "Setup Complete on Day One",
  "pricing.equipment.note2": "Zero wasted spending, start creating immediately",
  "pricing.equipment.essentialsTitle": "Starting from zero",
  "pricing.equipment.essentialsSub": "Required equipment & plugins at course start",
  "pricing.equipment.essentialsNote": "Plug-in fees for the first month are also required.\nPrices are subject to change depending on the timing.",
  "pricing.equipment.instructorNote": "※All equipment is purchased and arranged by the instructor. Members can start creating immediately without any hassle.",
  "pricing.equipment.extraCost": "※Equipment support requires additional equipment costs.",

  "pricing.followup.title": "Post 1-Term (6-Month) Follow-up System",
  "pricing.followup.plan": "Total 6 sessions",
  "pricing.followup.price": "¥330,000",
  "pricing.followup.periodNote": "* 6-month validity",
  "pricing.followup.note": "",
  "pricing.followup.b1": "Maintaining motivation",
  "pricing.followup.b2": "Maintaining quality",
  "pricing.followup.b3": "Acquiring cross-genre knowledge",
  "pricing.followup.b4": "Learning emerging trend techniques",
  "pricing.followup.f1": "4 sessions/month, one-on-one",
  "pricing.followup.f2": "4 sessions/month plus optional individual support on separate days",

  "pricing.plan1.f_support": "4 monthly sessions plus optional individual support sessions upon request",
  "pricing.plan1.noteReview": "*Monthly review required; completing assignments is a prerequisite",
  "pricing.plan1.noteInquiry": "Please contact us for details",
  "pricing.equipment.note3": "Costs presented and discussed per case. Full details provided before any purchase",

  "pricing.steps.tag": "Learning Steps",
  "pricing.steps.title": "Learning Steps",
  "pricing.steps.subtitle": "The journey from zero to professional composition quality.\nHere is how you grow.",
  "pricing.steps.note": "We propose the optimal design plan tailored to each member's experience and goals.\nPlease let us know your current production status and desired direction when you inquire.",
  "pricing.step1.label": "FOUNDATION",
  "pricing.step1.month": "Month 01",
  "pricing.step1.title": "Setup & First Track",
  "pricing.step1.desc": "All plugins fully set up. Basic DAW operation, MIDI input, and simple chord progressions. By the end of the first step, your first track takes shape.",
  "pricing.step2.label": "DEVELOPMENT",
  "pricing.step2.month": "Month 02",
  "pricing.step2.title": "Arrangement & Sound Design",
  "pricing.step2.desc": "Learn to select virtual instruments, program drums and bass, and master effect fundamentals. Aim for richer sound.",
  "pricing.step3.label": "COMPLETION",
  "pricing.step3.month": "Month 03",
  "pricing.step3.title": "Mixing & Mastering",
  "pricing.step3.desc": "Master EQ, compressor and reverb to achieve professional sound quality. Complete your original track in the final step.",

  "pricing.step4.label": "REPETITION",
  "pricing.step4.month": "Month 04",
  "pricing.step4.title": "Repetitive Production ①",
  "pricing.step4.desc": "Put acquired skills into repeated practice. Work on multiple genres until the techniques become second nature. Broaden your expressive range with instructor feedback.",

  "pricing.step5.label": "REPETITION",
  "pricing.step5.month": "Month 05",
  "pricing.step5.title": "Repetitive Production ②",
  "pricing.step5.desc": "Take on more complex arrangements. Through repeated production, the professional workflow becomes instinctive. This is when you discover your 'strength'.",

  "pricing.step6.label": "FINAL",
  "pricing.step6.month": "Month 06",
  "pricing.step6.title": "Final Polish",
  "pricing.step6.desc": "The culmination of 6 months. With repeatedly honed skills, complete a pro-quality demo track. This is where your real journey begins.",

  "pricing.limit.note": "To provide ample time and support for each individual, each term is limited to 4 students.",

  "pricing.cta.tag": "First Step",
  "pricing.cta.title": "Take the First Step",
  "pricing.cta.desc": "One-on-one consulting for 6 months.\nFrom zero to professional composition quality. Start with a membership inquiry.",
  "pricing.cta.button1": "Membership Inquiry",
  "pricing.cta.button2": "",

  "cta.title": "A Creative Experience, Reserved for You.",
  "cta.description": "To provide ample time and support for each individual, each term is limited to 4 students.\n\nWe operate on a 6-month term basis. If enrollment fills up, the next available term will be in 6 months.\n\nRegistration closes once capacity is reached, so please inquire early.\n\nShould a vacancy arise, those on the waitlist will be prioritized.",
  "cta.button": "Membership Inquiry",
  "footer.logo": "Maison Sound",
  "footer.description": "Fully private composition consulting by active professional composers",
  "footer.column1.title": "About",
  "footer.column1.link1": "Instructors",
  "footer.column1.link2": "Curriculum",
  "footer.column1.link3": "",
  "footer.column1.link4": "",
  "footer.column2.title": "Contact",
  "footer.column2.link1": "Inquiry",
  "footer.column2.link2": "",
  "footer.column2.link3": "Payment",
  "footer.column2.link4": "FAQ",
  "footer.column3.title": "Legal",
  "footer.column3.link1": "Privacy Policy",
  "footer.column3.link2": "Terms of Use",
  "footer.copyright": "© 2025 Maison Sound. All rights reserved.",
  "footer.newsletter.placeholder": "Email address",
  "footer.newsletter.button": "Contact Us",

  "inquiry.hero.tag": "Contact",
  "inquiry.hero.title": "Inquiry",
  "inquiry.hero.subtitle": "The first step toward special musical creation. Please feel free to reach out.",

  "inquiry.form.name": "Full Name",
  "inquiry.form.email": "Email Address",
  "inquiry.form.phone": "Phone Number",
  "inquiry.form.format": "Preferred Lesson Format",
  "inquiry.format.inPerson": "In-Person Lesson",
  "inquiry.format.online": "Online Lesson",
  "inquiry.form.interest": "Areas of Interest",
  "inquiry.interest.composition": "Composition & Arrangement",
  "inquiry.interest.dtm": "DTM & DAW",
  "inquiry.interest.mix": "Mixing & Mastering",
  "inquiry.interest.equipment": "Equipment & Setup",
  "inquiry.form.level": "Current Music Experience",
  "inquiry.level.beginner": "Beginner (starting from scratch)",
  "inquiry.level.intermediate": "Some experience (self-taught)",
  "inquiry.level.advanced": "Advanced (already have works)",
  "inquiry.form.message": "Questions & Requests",
  "inquiry.form.submit": "Submit",
  "inquiry.form.privacy": "Information provided will be used solely for responding to your inquiry.",
  "inquiry.form.emailLabel": "Membership Inquiry",
  "inquiry.form.emailDescription": "To help us assist you smoothly, please include the following information in your inquiry:\n\n・DAW you currently use\n・DAW experience (years of use)\n・Demo tracks (if available)\n・Goals you'd like to achieve within the next 6 months",
  "inquiry.form.responseTime": "* We typically respond within 1-2 business days",

  "privacy.hero.label": "Legal",
  "privacy.hero.title": "Privacy Policy",
  "privacy.lastUpdated": "Last Updated: June 2025",
  "privacy.section1.title": "1. Collection of Personal Information",
  "privacy.section1.p1": "This studio (hereinafter \"we\") may collect your name, email address, phone number, and other information necessary to respond to your inquiries and enrollment requests.",
  "privacy.section1.p2": "This information will be used solely to respond to your requests and consultations.",
  "privacy.section2.title": "2. Purpose of Use of Personal Information",
  "privacy.section2.p1": "Collected personal information will be used for the following purposes:",
  "privacy.section2.li1": "Provision and operation of lessons and consulting services",
  "privacy.section2.li2": "Responding to inquiries",
  "privacy.section2.li3": "Service improvement and reference for new service development",
  "privacy.section2.li4": "Notification of important announcements and changes to contract terms",
  "privacy.section3.title": "3. Provision of Personal Information to Third Parties",
  "privacy.section3.p1": "We will not provide your personal information to any third party except in the following cases:",
  "privacy.section3.li1": "When we have your consent",
  "privacy.section3.li2": "When required by law",
  "privacy.section3.li3": "When necessary for the protection of life, body, or property",
  "privacy.section3.li4": "When particularly necessary for improving public health or promoting the sound development of children",
  "privacy.section4.title": "4. Management of Personal Information",
  "privacy.section4.p1": "We will appropriately manage collected personal information and strive to prevent leakage, loss, alteration, etc. Access to personal information is restricted to the minimum necessary personnel and is stored with strict security.",
  "privacy.section5.title": "5. Access Analysis Tools",
  "privacy.section5.p1": "This website may use access analysis tools (such as Google Analytics) for the purpose of service improvement.",
  "privacy.section5.p2": "These tools collect traffic data using cookies, but no personally identifiable information is included.",
  "privacy.section6.title": "6. Contact Information",
  "privacy.section6.p1": "For inquiries, disclosure, correction, or deletion of personal information, please contact us below.",
  "privacy.section6.link": "Inquiry Form",
  "privacy.section7.title": "7. Revisions",
  "privacy.section7.p1": "This policy may be revised without prior notice due to changes in laws and regulations or service content. The revised policy shall become effective from the time it is posted on this page.",

  "features.tag": "Lesson Features",
  "features.title": "An Experience Found Nowhere Else",
  "features.equipment.title": "Equipment Selection Support",
  "features.equipment.desc": "We provide comprehensive proposals for PCs, DAWs, sound libraries, and subscriptions. Active professionals curate only what you truly need. Even starting from zero, you can begin creating immediately with zero wasted spending.",
  "features.equipment.item1": "WAVES Horizon ¥40,700",
  "features.equipment.item2": "DAW (Studio One recommended) ¥20,800",
  "features.equipment.item3": "Logitech trackball mouse ¥17,800",
  "features.equipment.item4": "Audio interface & cables ¥40,700",
  "features.equipment.item5": "Microphone (with cable, stand, pop guard) ¥30,700",
  "features.equipment.item6": "MIDI keyboard",
  "features.equipment.item7": "Splice $12.99",
  "features.individual.title": "Fully Private & Exclusive",
  "features.individual.desc": "No group lessons. Four one-on-one sessions per month with active professional composers. Learning in the same environment and with the same equipment accelerates progress dramatically.",
  "features.individual.stat1": "vs 1",
  "features.individual.stat2": "sessions/month",
  "features.individual.stat3": "Group",
  "features.genre.title": "All Genres Welcome",
  "features.genre.desc": "From J-POP and DTM to band sounds, we cover a wide range. The curriculum is fully customized to match the music you want to create.",

  "features.equipment.note": "* Costs are presented and discussed on a case-by-case basis. Full details are provided before any purchase.",

  "faq.hero.tag": "FAQ",
  "faq.hero.title": "Frequently Asked Questions",
  "faq.hero.subtitle": "Answers to common questions about our composition consulting services.",
  "faq.bottomText": "For more detailed questions, please feel free to contact us.",
  "faq.q1.question": "I am a complete beginner. Can I still join?",
  "faq.q1.answer": "Absolutely. Our program is designed to accommodate those with zero musical experience. We provide thorough support from equipment selection to setup, so even first-timers can participate with confidence.",
  "faq.q2.question": "How often are the lessons and how long is each session?",
  "faq.q2.answer": "The standard is 4 one-on-one sessions per month, each approximately 90 minutes. In addition, optional individual support sessions are available on separate days upon request. In-person lessons are held in an exclusive professional studio, while online sessions use Zoom or Google Meet.",
  "faq.q3.question": "What equipment do I need?",
  "faq.q3.answer": "The basics include a PC, DAW software (Studio One recommended), an audio interface, and headphones or speakers. We provide guidance on what to choose during your initial counseling session.",
  "faq.q4.question": "Can I reschedule a lesson?",
  "faq.q4.answer": "In principle, rescheduling is possible with at least three days' notice. For last-minute changes, we will do our best to accommodate you, so please reach out to discuss.",
  "faq.q5.question": "Are online lessons as effective as in-person ones?",
  "faq.q5.answer": "Yes. We use screen sharing to provide real-time guidance while viewing the same screen as your instructor. Even detailed operations can be confirmed on the spot, making it popular with remote learners and frequent travelers.",
  "faq.q6.question": "What happens after the 6-month program ends?",
  "faq.q6.answer": "Upon completion, you may opt for our follow-up package. We also provide advice on self-directed production so you can continue creating independently.",
  "faq.q7.question": "Can I focus on a specific genre only?",
  "faq.q7.answer": "Of course. Whether it is J-POP, electronic music, or band sounds, we fully customize the curriculum around the music you want to create. You can also study with reference to a specific artist's work.",
  "faq.q8.question": "What payment methods do you accept?",
  "faq.q8.answer": "We accept bank transfers and credit card payments. Details will be provided during your enrollment counseling.",
  "faq.q9.question": "Are there assignments or support on days without lessons?",
  "faq.q9.answer": "In addition to 4 one-on-one sessions per month, we offer optional Zoom guidance 2-3 days per week for those who request it. Every session comes with assignments, so you will naturally engage with production work on a daily basis. This continuous cycle of input and output drives remarkable growth over the 6-month program.",

  "terms.hero.label": "Legal",
  "terms.hero.title": "Terms of Use",
  "terms.lastUpdated": "Last Updated: July 2025",
  "terms.section1.title": "Article 1 (Scope)",
  "terms.section1.p1": "These Terms of Use set forth the conditions for using the composition consulting services (\"Services\") provided by Maison Sound (\"the Studio\"). By using the Services, you are deemed to have agreed to all terms herein.",
  "terms.section2.title": "Article 2 (Enrollment)",
  "terms.section2.p1": "The Studio operates on a membership-only basis. Those wishing to enroll are required to contact the Studio directly.",
  "terms.section2.p2": "An enrollment fee of ¥110,000 is required upon joining. The enrollment fee is included in the program fee and is non-refundable.",
  "terms.section2.p3": "Each term is limited to a maximum of 4 participants. If enrollment reaches capacity, the next available term will generally be in 6 months.",
  "terms.section3.title": "Article 3 (Service Details)",
  "terms.section3.li1": "4 one-on-one consulting sessions per month (approx. 90 minutes each)",
  "terms.section3.li2": "Individual instruction in composition, arrangement, mixing, and mastering",
  "terms.section3.li3": "Equipment and software selection and environment setup support",
  "terms.section3.li4": "Additional individual support sessions on separate days upon request",
  "terms.section3.li5": "In-person lessons (professional-grade studio) or online lessons (Zoom / Google Meet)",
  "terms.section3.li6": "Program duration is 6 months per term",
  "terms.section4.title": "Article 4 (Fees and Payment)",
  "terms.section4.p1": "The program fee for both in-person and online consulting is ¥1,430,000 (tax included) per 6-month term, including the ¥110,000 enrollment fee.",
  "terms.section4.p2": "Payment can be made by bank transfer or credit card. Details will be provided during enrollment counseling.",
  "terms.section4.p3": "Equipment support incurs additional equipment costs. Costs are presented and discussed on a case-by-case basis, with full details provided before any purchase.",
  "terms.section4.p4": "A follow-up package (6 sessions, ¥330,000) is available upon request after completing one 6-month term.",
  "terms.section5.title": "Article 5 (Cancellation and Rescheduling)",
  "terms.section5.p1": "In principle, lesson rescheduling is possible with at least 3 days' advance notice.",
  "terms.section5.p2": "For last-minute schedule changes, we will do our best to accommodate you, so please reach out to discuss.",
  "terms.section5.p3": "No-shows on the day of the lesson without prior notice will generally not be eligible for a make-up session.",
  "terms.section6.title": "Article 6 (Early Termination)",
  "terms.section6.p1": "This program is designed as a 6-month term, and early termination during the program period is generally not accepted.",
  "terms.section6.p2": "If early termination is unavoidable due to extenuating circumstances, please contact us promptly. We will consider individual arrangements based on the situation.",
  "terms.section6.p3": "If early termination is approved, a settlement will be made based on the remaining period. The enrollment fee is non-refundable.",
  "terms.section7.title": "Article 7 (Prohibited Conduct)",
  "terms.section7.li1": "Unauthorized recording, filming, streaming, or posting of lesson content on social media",
  "terms.section7.li2": "Harassment or disruptive behavior toward the instructor or other participants",
  "terms.section7.li3": "Improper use or damage of studio equipment used during lessons",
  "terms.section7.li4": "Acts that damage the reputation of the Studio",
  "terms.section7.li5": "Unauthorized sharing or resale of teaching materials and know-how provided during lessons to third parties",
  "terms.section8.title": "Article 8 (Disclaimer)",
  "terms.section8.p1": "The Studio does not guarantee the commercial success or specific outcomes of participants' works. The Services are intended solely to provide skills and knowledge.",
  "terms.section8.p2": "Proposals regarding equipment purchases and setup are provided as reference information based on the instructor's expertise. The final purchasing decision rests with the participant.",
  "terms.section8.p3": "If a lesson cannot be conducted due to natural disasters, power outages, communication failures, or other force majeure events, the Studio shall not be liable for any resulting damages. A rescheduled session shall serve as the remedy.",
  "terms.section9.title": "Article 9 (Handling of Personal Information)",
  "terms.section9.p1": "Personal information provided by customers will be used solely for the purpose of providing the Services and related communications, and will not be disclosed to third parties. Please refer to the Privacy Policy for further details.",
  "terms.section10.title": "Article 10 (Changes to Terms)",
  "terms.section10.p1": "The Studio may revise these Terms as necessary. The revised Terms shall take effect from the time they are posted on this page. In the event of significant changes, members will be notified in advance.",
};